var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',[(_vm.error === _vm.RoomErrors.UNAUTHORIZED)?_c('div',{staticClass:"mb-3"},[_vm._v(" "+_vm._s(_vm.$t('errorText'))+" ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }